<template>
  <div
    class="relative flex h-full flex-col rounded-md bg-cover bg-top p-14 text-white lg:min-h-[768px] lg:py-16"
    :style="{
      backgroundImage:
        !videoSrc && image ? `url(${getAssetUrl(image, {})})` : undefined,
    }"
  >
    <UiVideo
      v-if="videoSrc"
      :src="videoSrc"
      class="absolute inset-0"
      container-size
      autoplay
    />

    <div
      class="absolute inset-0 z-10 bg-cover bg-center bg-no-repeat"
      data-background="/images/solutions/overlay.png"
    ></div>

    <div class="relative z-20 flex h-full flex-col">
      <UiSectionTitle
        v-if="title"
        :title="title"
        tag="h3"
        class="title mb-2 whitespace-pre-line text-5xl uppercase lg:text-[3.5rem]"
      />

      <div v-if="text" class="mb-6 text-md">
        <span class="whitespace-pre-line" v-html="text" />
      </div>

      <div v-if="button && button.isVisible" class="mb-6">
        <UiButton
          v-if="button.isVideoOpener"
          size="md"
          icon="play"
          @click="playVideo"
        >
          <span v-html="button.text" />
        </UiButton>

        <UiButton
          v-else-if="button.link"
          :to="button.link"
          :target="button.target"
          size="md"
        >
          <span v-html="button.text" />
        </UiButton>
      </div>

      <div v-if="features && features.length" class="mt-auto flex gap-x-4">
        <div
          v-for="(feature, i) in features"
          :key="i"
          class="gradient-slate w-[188px] rounded-lg p-4 pt-[1.125rem] text-sm"
        >
          <div
            class="mb-5 h-8 w-8 bg-contain bg-left bg-no-repeat"
            :style="{
              backgroundImage: feature.icon
                ? `url(${getAssetUrl(feature.icon, {})})`
                : undefined,
            }"
          ></div>

          <div
            class="title mb-2 max-w-[140px] uppercase"
            v-html="feature.title"
          />

          <div class="leading-5" v-html="feature.text" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useMediaAsset } from '~/composables';

interface Props {
  image?: string;
  video?: string;
  videoId?: string;
  title?: string;
  text?: string;
  button?: any;
  features?: any[];
}

interface Emits {
  (e: 'play', data: Props['videoId']): void;
}

const props = withDefaults(defineProps<Props>(), {
  image: '',
  video: '',
  videoId: '',
  title: '',
  text: '',
  button: () => ({}),
  features: () => [],
});

const emit = defineEmits<Emits>();

const { getAssetUrl } = useMediaAsset();

const videoSrc = computed(() => getAssetUrl(props.video));
const playVideo = () => {
  emit('play', props.videoId);
};
</script>
